module.exports = __webpack_public_path__ + "static/clients-small-592bb558525ba9e99abc23cf187b6720.svg";